import React from 'react';
import { 
  Globe, 
  Smartphone, 
  Calendar, 
  Image, 
  Share2, 
  BarChart3, 
  RefreshCw,
  Check
} from 'lucide-react';
import { featuresData } from '../data/mock';

const iconMap = {
  Globe,
  Smartphone,
  Calendar,
  Image,
  Share2,
  BarChart3,
  RefreshCw,
};

const FeaturesSection = () => {
  return (
    <section className="section bg-[#0F0F15]" id="features">
      <div className="container mx-auto px-4 md:px-6">
        <div className="text-center max-w-2xl mx-auto mb-16">
          <span className="inline-block text-sm font-semibold text-[#FF6B35] uppercase tracking-wider mb-4">
            Features
          </span>
          <h2 className="heading-1 mb-4">
            Everything You Need to{' '}
            <span className="gradient-text">Win Online</span>
          </h2>
          <p className="body-large">
            Every feature is designed with one goal: turning your followers into customers, clients, and fans.
          </p>
        </div>
        
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8">
          {featuresData.map((feature, index) => {
            const IconComponent = iconMap[feature.icon];
            return (
              <div 
                key={feature.id}
                className="card group animate-fade-in-up"
                style={{ animationDelay: `${index * 0.1}s` }}
              >
                <div className="feature-icon mb-5 group-hover:scale-110 transition-transform">
                  <IconComponent size={26} />
                </div>
                <h3 className="text-xl font-semibold text-white mb-3">
                  {feature.title}
                </h3>
                <p className="body-medium text-[#6B6B78]">
                  {feature.description}
                </p>
              </div>
            );
          })}
        </div>
        
        {/* Bottom highlight */}
        <div className="mt-16 bg-gradient-to-r from-[#12121A] to-[#1A1A24] rounded-2xl p-8 md:p-12 border border-[#2A2A35]">
          <div className="grid md:grid-cols-2 gap-8 items-center">
            <div>
              <h3 className="text-2xl md:text-3xl font-bold text-white mb-4">
                Optimized for{' '}
                <span className="gradient-text">Every Platform</span>
              </h3>
              <p className="text-[#B8B8C0] mb-6">
                Your site works seamlessly with Instagram, TikTok, Facebook, Twitter, 
                YouTube, and any platform where your audience lives.
              </p>
              <div className="flex flex-wrap gap-3">
                {['Instagram', 'TikTok', 'Facebook', 'YouTube', 'Twitter'].map((platform) => (
                  <span 
                    key={platform}
                    className="inline-flex items-center gap-2 bg-[#0A0A0F] border border-[#2A2A35] px-4 py-2 rounded-full text-sm text-white"
                  >
                    <Check size={14} className="text-[#FF6B35]" />
                    {platform}
                  </span>
                ))}
              </div>
            </div>
            <div className="flex justify-center">
              <div className="grid grid-cols-3 gap-4">
                {[1, 2, 3, 4, 5, 6].map((i) => (
                  <div 
                    key={i}
                    className="w-16 h-16 md:w-20 md:h-20 rounded-xl bg-[#0A0A0F] border border-[#2A2A35] flex items-center justify-center"
                    style={{ animation: `float ${3 + i * 0.3}s ease-in-out infinite ${i * 0.2}s` }}
                  >
                    <div className="w-8 h-8 md:w-10 md:h-10 rounded-lg bg-gradient-to-br from-[#FF6B35]/20 to-[#00D4FF]/20" />
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FeaturesSection;
